export const webWidth = 760
export const displayImg = 200